import { RegisterType } from 'types';

import { Input } from 'components/Input';
import { Headline } from 'components/Headline';

import * as S from './Variant.styles';

type VariantProps = {
  register: RegisterType;
};

const defaultProps: Partial<VariantProps> = {};

export function Variant(props: VariantProps): React.ReactElement {
  const { register } = { ...defaultProps, ...props };

  return (
    <S.Container>
      <S.BlindImage>
        <Headline color="blueLight">150x150</Headline>
      </S.BlindImage>

      <S.InputGroup>
        <Input register={register} motive="m2" label="Shop Code" name="shopCode" disabled />

        <Input register={register} motive="m2" flag="en" label="Campo 1" name="campo1" />

        <Input register={register} motive="m2" flag="it" name="campo1" />
      </S.InputGroup>

      <S.InputGroup>
        <Input register={register} motive="m2" label="Qta." name="quantity" />
      </S.InputGroup>

      <S.DeleteButton iconLeft="FiDelete" motive="delete" />
    </S.Container>
  );
}
